import React from 'react';
import { NotFound } from 'components';

const NotFoundPage = () => <NotFound />;

export default NotFoundPage;
